<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { chain, debounce, groupBy } from 'lodash'
import { Errors } from 'form-backend-validation'
import {
  ScoreComponentEntry,
  StudentScoreEntryComponent,
  InvoiceComponent,
  StudentScoreGrading,
  StudentSubscription
} from '../components'
export default {
  name: 'studentTransferV2',
  components: {
    ScoreComponentEntry,
    StudentScoreEntryComponent,
    InvoiceComponent,
    StudentScoreGrading,
    StudentSubscription
  },
  data() {
    return {
      selectedStudent: undefined,
      errors: new Errors(),
      loading: false,
      classes: [],
      to_classes: [],
      branches: [],
      studentScoreAndComponent: [],
      gradeSubjects: [],
      serviceSubscriptionResource: {},
      invoiceResources: {},
      acStatusId: 1,
      model: {
        student_id: '',
        to_branch_id: '',
        from_class_id: '',
        to_class_id: '',
        from_grade_id: '',
        to_grade_id: '',
        date_transfer: moment().format('DD-MM-YYYY'),
        comment: '',
        to_current_branch: true,
        scoreComponentEntries: {},
        scoreEntries: {},
        serviceSubscription: [],
        scoreGrading: [],
        invoices: []
      }
    }
  },
  computed: {
    studentToClasList() {
      return this.classes.map(el => ({
        value: el.class_id + '_' + el.student_id,
        label: `${el.card_number}-${el.first_name_en} ${el.last_name_en}| ${el.class_name}-${el.class_desc}|${el.teacher_name}`,
        ...el
      }))
    },
    toClassesOption() {
      return this.to_classes.map(el => ({
        value: el.class_id,
        label: `${el.class_name}-${el.class_desc}|${el.teacher_name}`,
        ...el
      }))
    }
  },
  mounted() {
    this.fetchStudentClass()
  },
  methods: {
    ...mapActions('studentTransferModule', [
      'onGetStudent',
      'onGetBranch',
      'onGetToClasses',
      'onGetScoreComponentEntry',
      'onGetScoreGrading',
      'onGetSubjectItem',
      'onGetServiceSubscription',
      'onGetInvoice',
      'onSave'
    ]),
    onSearch: debounce(function(value) {
      if (!value) return
      this.fetchStudentClass(value)
    }, 800),
    fetchStudentClass(value) {
      this.loading = true
      this.classes.length = 0
      this.onGetStudent({
        search: value,
        ac_status_id: this.acStatusId
      })
        .then(result => {
          this.classes = result.data.data
        })
        .catch(err => {
          this.$notify({ type: 'error', text: err.response.data.message })
        })
        .finally(() => (this.loading = false))
    },
    onToCurrentBranchHandler(value) {
      this.model.to_class_id = undefined

      if (value) {
        this.model.to_branch_id = undefined
        this.onFetchToClass()
        return
      }

      this.loading = true
      this.to_classes = []
      this.clearScore()
      this.onGetBranch()
        .then(result => {
          this.branches = result.data.data.map(el => ({
            value: el.branch_id,
            label: `${el.branch_name_kh}-${el.branch_name_en}`
          }))
        })
        .catch(err => {
          this.$notify({ type: 'error', text: err.response.data.message })
        })
        .finally(() => (this.loading = false))
    },
    onStudentChange(value, option) {
      const [classId, studentId] = value.split('_')
      this.model.from_grade_id = parseInt(option.data.props.grade_id)
      this.model.student_id = studentId
      this.model.from_class_id = parseInt(classId)
      this.model.to_class_id = undefined
      this.onFetchToClass()
    },
    onFetchToClass() {
      this.loading = true
      this.model.to_class_id = undefined
      this.to_classes = []
      this.clearScore()
      this.onGetToClasses({
        to_branch_id: this.model.to_branch_id,
        ac_status_id: this.acStatusId
      })
        .then(result => {
          this.to_classes = result.data.data
        })
        .catch(err => {
          this.$notify({ type: 'error', text: err.response.data.message })
        })
        .finally(() => (this.loading = false))
    },
    onBranchChange() {
      this.onFetchToClass()
    },
    async onToClassChange(_value, option) {
      this.model.to_grade_id = parseInt(option.data.props.grade_id)
      this.clearScore()
      this.loading = true

      const scoreGrading = await this.onGetScoreGrading({
        classId: this.model.from_class_id,
        studentId: this.model.student_id
      })

      this.model.scoreGrading = scoreGrading.data.data.map(el => ({
        sc_subject_id: el.sc_subject_id,
        subject_name_native: el.subject_name_native,
        class_id: el.class_id,
        student_id: el.student_id,
        new_sc_subject_id: ''
      }))

      await this.onGetScoreComponentEntry({
        classId: this.model.from_class_id,
        studentId: this.model.student_id
      })
        .then(result => ({ score: result.data.data }))
        .then(async ({ score }) => {
          const response = await this.onGetSubjectItem(this.model.to_grade_id)
          this.studentScoreAndComponent = score
          this.gradeSubjects = response.data.data
        })
        .catch(err => {
          this.$notify({ type: 'error', text: err.response.data.message })
        })

      const invoiceReponse = await this.onGetInvoice({
        studentId: this.model.student_id,
        classId: this.model.from_class_id,
        toGradeId: this.model.to_grade_id,
        branchId: this.model.to_branch_id
      })
      this.invoiceResources = invoiceReponse.data.data

      await this.onFetchStudentScription()

      this.createInitial()
      this.loading = false
    },
    async onFetchStudentScription() {
      if (!this.model.to_current_branch) {
        const response = await this.onGetServiceSubscription({
          studentId: this.model.student_id,
          toGradeId: this.model.to_grade_id,
          branchId: this.model.to_branch_id
        })
        this.serviceSubscriptionResource = response.data.data
      }
    },
    createInitial() {
      if (this.studentScoreAndComponent.hasOwnProperty('componentEntry')) {
        const initialData = this.studentScoreAndComponent.componentEntry.map(
          el => ({
            display_subject: el.subject_name_native,
            old_subject: el.subject_id,
            new_subject_id: '',
            old_subject_comp_id: el.subject_comp_id,
            display_subject_comp: el.comp_item_name,
            new_subject_comp_id: '',
            old_subject_comp_detail_id: el.subject_comp_detail_id,
            display_subject_comp_detail: el.subject_comp_item_detail_name,
            new_subject_comp_detail_id: ''
          })
        )
        this.findNewSubjectComponent(initialData)
        this.model.scoreComponentEntries = chain(initialData)
          .groupBy('display_subject')
          .mapValues(displaySubjectCompGroup =>
            groupBy(displaySubjectCompGroup, 'display_subject_comp')
          )
          .value()
      }

      if (this.studentScoreAndComponent.hasOwnProperty('scoreEntry')) {
        const initScoreEntry = this.studentScoreAndComponent.scoreEntry.map(
          el => ({
            subject_name_native: el.subject_name_native,
            sc_subject_id: el.sc_subject_id,
            new_sc_subject_id: '',
            old_sc_item_subject_comp_id: el.sc_item_subject_comp_id,
            new_sc_item_subject_comp_id: '',
            comp_item_name: el.comp_item_name
          })
        )

        this.findNextComponent(initScoreEntry)

        this.model.scoreEntries = groupBy(initScoreEntry, 'subject_name_native')
      }
      if (this.invoiceResources.hasOwnProperty('invoices')) {
        this.model.invoices = this.invoiceResources.invoices.map(el => ({
          inv_id: el.inv_id,
          class_id: el.class_id,
          d_class_id: el.d_class_id,
          fee_type_id: el.fee_type_id,
          fee_type_name: el.fee_type_name,
          fee_setup_id: el.fee_setup_id,
          fee_name_en: el.fee_name_en,
          to_fee_setup_id: '',
          fee_description: el.fee_description
        }))
      }
      if (this.serviceSubscriptionResource.hasOwnProperty('subscription')) {
        this.model.serviceSubscription = this.serviceSubscriptionResource.subscription.map(
          el => ({
            fee_type_name: el.fee_type_name,
            fee_name_en: el.fee_name_en,
            fee_setup_id: parseInt(el.fee_setup_id),
            fee_type_id: parseInt(el.fee_type_id),
            to_fee_setup_id: ''
          })
        )
      }
    },
    findNewSubjectComponent(initialData) {
      initialData.forEach(el => {
        // find subject
        const subjects = this.gradeSubjects.filter(
          s => s.subject_name_native === el.display_subject
        )
        if (subjects.length) {
          el.new_subject_id = subjects[0].subject_id

          // find subject component
          const components = subjects.filter(
            com => com.comp_item_name === el.display_subject_comp
          )

          if (components.length) {
            el.new_subject_comp_id = components[0].subject_comp_id

            // sub item
            const subItem = components.find(
              sub =>
                sub.subject_comp_item_detail_name ===
                el.display_subject_comp_detail
            )

            if (subItem !== undefined) {
              el.new_subject_comp_detail_id = parseInt(
                subItem.subject_comp_detail_id
              )
            }
          }
        }
      })
    },
    findNextComponent(initialData) {
      initialData.forEach(el => {
        // find subject
        const subjects = this.gradeSubjects.filter(
          s => s.subject_name_native === el.subject_name_native
        )
        if (subjects.length) {
          el.new_sc_subject_id = subjects[0].subject_id
          // find subject component
          const components = subjects.filter(
            com => com.comp_item_name === el.comp_item_name
          )
          if (components.length) {
            el.new_sc_item_subject_comp_id = components[0].subject_comp_id
          }
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    clearScore() {
      this.model.scoreComponentEntries = []
      this.model.scoreEntries = []
      this.model.serviceSubscription = []
      this.model.invoices = []
      this.model.scoreGrading = []
      this.studentScoreAndComponent = {}
      this.serviceSubscriptionResource = {}
      this.invoiceResources = {}
    },
    onStatusChange() {
      this.selectedStudent = undefined
      this.classes = []
      this.to_classes = []
      this.branches = []
      this.studentScoreAndComponent = []
      this.gradeSubjects = []
      this.invoiceResources = {}
      this.serviceSubscriptionResource = {}

      // clear model
      this.model.student_id = undefined
      this.model.to_branch_id = undefined
      this.model.from_class_id = undefined
      this.model.to_class_id = undefined
      this.model.from_grade_id = undefined
      this.model.to_grade_id = undefined
      this.model.scoreComponentEntries = []
      this.model.scoreEntries = []
      this.model.serviceSubscription = []
      this.model.invoices = []

      this.fetchStudentClass()
    },
    onSaveHandler() {
      this.loading = true
      this.onSave(this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.$router.push({ name: 'student-transfer' })
        })
        .catch(err => {
          this.errors = new Errors(err.response.data.errors)
          this.$toasted.error(err.response.data.message)
        })
        .finally(() => (this.loading = false))
    },
    onSaveAddNewHandler() {
      this.loading = true
      this.onSave(this.model)
        .then(response => {
          this.$toasted.success(response.data.message)
          this.clearInput()
        })
        .catch(err => {
          this.errors = new Errors(err.response.data.errors)
          this.$toasted.error(err.response.data.message)
        })
        .finally(() => (this.loading = false))
    },
    clearInput() {
      this.model.comment = ''
      this.onStatusChange()
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentTransfer.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentTransfer.pageTitle'),
            href: 'v2/student-transfers'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-12">
                  <div class="ts-flex ts-justify-between ts-items-center">
                    <label class="required">{{
                      $t('studentTransfer.studentName')
                    }}</label>
                    <a-radio-group
                      v-model="acStatusId"
                      @change="onStatusChange"
                    >
                      <a-radio :value="1">
                        {{ $t('studentTransfer.current') }}
                      </a-radio>
                      <a-radio :value="3">
                        {{ $t('studentTransfer.next') }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                  <a-select
                    v-model="selectedStudent"
                    :options="studentToClasList"
                    class="ts-w-full"
                    :placeholder="$t('studentTransfer.typeSearchStudent')"
                    showSearch
                    @search="onSearch"
                    @change="onStudentChange"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                  ></a-select>
                  <div class="ts-text-red-500" v-if="errors.has('student_id')">
                    {{ errors.first('student_id') }}
                  </div>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="col-md-12">
                  <div class="ts-flex ts-space-x-3">
                    <div class="ts-w-48">
                      <ts-checkbox
                        v-model="model.to_current_branch"
                        @change="onToCurrentBranchHandler"
                        >{{
                          $t('studentTransfer.toCurrentBranch')
                        }}</ts-checkbox
                      >
                    </div>
                    <div class="ts-w-full">
                      <a-select
                        v-model="model.to_branch_id"
                        :options="branches"
                        class="ts-w-full"
                        :placeholder="$t('studentTransfer.transferToBranch')"
                        :disabled="model.to_current_branch"
                        @change="onBranchChange"
                      ></a-select>
                      <div
                        class="ts-text-red-500"
                        v-if="errors.has('to_branch_id')"
                      >
                        {{ errors.first('to_branch_id') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="col-md-12">
                  <label class="required">{{
                    $t('studentTransfer.toClass')
                  }}</label>
                  <a-select
                    v-model="model.to_class_id"
                    :options="toClassesOption"
                    class="ts-w-full"
                    :placeholder="$t('studentTransfer.toClass')"
                    showSearch
                    :filterOption="filterOption"
                    optionFilterProp="children"
                    @change="onToClassChange"
                    :disabled="!model.from_class_id"
                  ></a-select>
                  <div class="ts-text-red-500" v-if="errors.has('to_class_id')">
                    {{ errors.first('to_class_id') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label class="required">{{
                $t('studentTransfer.comment')
              }}</label>
              <textarea
                v-model="model.comment"
                class="ts-w-full ts-border ts-rounded ts-p-2 ts-outline-none"
                rows="8"
              >
              </textarea>
              <div class="ts-text-red-500" v-if="errors.has('comment')">
                {{ errors.first('comment') }}
              </div>
            </div>
          </div>

          <ScoreComponentEntry
            class="ts-mt-4"
            v-if="Object.values(model.scoreComponentEntries).length"
            v-model="model"
            :studentScoreAndComponent="studentScoreAndComponent"
            :gradeSubjects="gradeSubjects"
            :validate="errors"
          />
          <StudentScoreEntryComponent
            class="ts-mt-4"
            v-if="Object.values(model.scoreEntries).length"
            v-model="model"
            :studentScoreAndComponent="studentScoreAndComponent"
            :gradeSubjects="gradeSubjects"
            :validate="errors"
          />
          <StudentScoreGrading
            v-if="model.scoreGrading.length"
            v-model="model"
            class="ts-mt-4"
            :gradeSubjects="gradeSubjects"
            :validate="errors"
          />
          <InvoiceComponent
            v-if="model.invoices.length"
            v-model="model"
            class="ts-mt-4"
            :invoiceResources="invoiceResources"
            :validate="errors"
          />
          <StudentSubscription
            v-if="model.serviceSubscription.length"
            v-model="model"
            class="ts-mt-4"
            :serviceSubscriptionResource="serviceSubscriptionResource"
            :validate="errors"
          />
          <div
            class="ts-flex ts-items-center ts-justify-end ts-space-x-3 ts-mt-3"
          >
            <ts-button @click="$router.push({ name: 'student-transfer' })">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              @click.prevent="onSaveAddNewHandler"
              color="primary"
              outline
              class="ml-2"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              @click.prevent="onSaveHandler"
              color="primary"
              class="ml-2"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
